module.exports = __webpack_public_path__ + "img/client-say-1.ad46eb56.png";